<lcs-advanced-multi-select
   [headerText]="entityName"
   class="reports-multi-select"
   [triggerConfig]="triggerConfig()"
   [datasources]="[dataSource()]"
   [hasRestoreDefaults]="false"
   (init)="onInit($event)"
   (save)="onSave($event)"
   (search)="onSearch($event)"
   (openDialog)="onOpen($event)"
   (selectedItemsChange)="onSelectedItemsChange($event)"
   (close)="onClose($event)"
>
   <ng-template let-context advancedMultiSelectTriggerDisplay>
      <lcs-advanced-multi-select-trigger [context]="context" (allChange)="onAllChange($event)">
         <ng-container errors>Please select at least one Extension</ng-container>
      </lcs-advanced-multi-select-trigger>
   </ng-template>
   <ng-template let-context advancedMultiSelectQuickFilters> </ng-template>

   <ng-template let-context advancedMultiSelectItemListDisplay>
      @for (item of context.items; track item.extensionId) {
      <div>
         <lcs-advanced-multi-select-item
            [context]="context"
            [item]="item"
            [selected]="isExtensionSelected(context.state.selectedItems(), item)"
         >
            {{ item.number }} - {{ item.name }}
         </lcs-advanced-multi-select-item>
      </div>
      }
   </ng-template>
</lcs-advanced-multi-select>
